var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame19873(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4rugam5lca)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.869 44c5.45 0 9.869-4.477 9.869-10s-4.419-10-9.87-10C10.419 24 6 28.477 6 34s4.418 10 9.869 10z",
    fill: "#EE0005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.13 44C33.582 44 38 39.523 38 34s-4.419-10-9.87-10c-5.45 0-9.868 4.477-9.868 10s4.418 10 9.869 10z",
    fill: "#F9A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.262 34a10.094 10.094 0 0 0 .981 4.354A9.961 9.961 0 0 0 22 41.838a9.977 9.977 0 0 0 2.754-3.484 10.11 10.11 0 0 0 0-8.704A9.977 9.977 0 0 0 22 26.165a9.961 9.961 0 0 0-2.756 3.483 10.094 10.094 0 0 0-.982 4.353z",
    fill: "#FF6300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.983 5-2.208 13.98h3.53L21.512 5h-3.529zm10.648 5.692c-1.233-.62-1.99-1.038-1.99-1.67.016-.577.64-1.167 2.035-1.167.903-.027 1.8.15 2.628.516l.321.146.48-2.924a8.777 8.777 0 0 0-3.168-.575c-3.485 0-5.94 1.843-5.955 4.477-.028 1.945 1.753 3.024 3.1 3.672 1.366.665 1.831 1.096 1.831 1.684-.015.906-1.104 1.324-2.12 1.324a7.079 7.079 0 0 1-3.312-.72l-.465-.214-.493 3.038a10.86 10.86 0 0 0 3.937.72c3.704 0 6.114-1.814 6.145-4.623.001-1.54-.941-2.72-2.975-3.684h.001zm12.522-5.648h-2.732a1.729 1.729 0 0 0-1.112.24 1.774 1.774 0 0 0-.733.884l-5.244 12.804h3.704l1.02-2.772h4.146l.53 2.783h3.267l-2.846-13.94zm-4.066 8.36c.071.007 1.422-4.523 1.422-4.523l1.078 4.523h-2.5zM12.825 5.001l-3.459 9.494-.376-1.872a10.38 10.38 0 0 0-4.88-5.674L7.275 18.96h3.735l5.55-13.959H12.825z",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83 6.802a2.349 2.349 0 0 0-.834-1.31 2.281 2.281 0 0 0-1.458-.49H.057L0 5.262A13.357 13.357 0 0 1 5.346 7.95a13.64 13.64 0 0 1 3.675 4.776L7.83 6.802z",
    fill: "#F7981D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4rugam5lca"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v48H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame19873);
export default __webpack_public_path__ + "static/media/frame-19873.6aa9cec38e2cb1946da1bddeba73b164.svg";
export { ForwardRef as ReactComponent };